<template>
  <v-card flat v-if="ready && user && !tvasIsLoading">
    <head-dialog-link :ligne="ligne" :close="closePopup" />
    <show-attr-ligne
      :modify_ligne="modify_ligne"
      v-model="ligne"
      :montant-ligne="montantGlobal()"
    />
    <v-divider />
    <v-card-text>
      <v-card flat>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col class="text-h1">
                {{ $t("ligneRob.dialog.chapitre.liaison") }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ ligne.linkRobCommandes.length }}
                {{ $t("ligneRob.dialog.chapitre.valide") }}
              </v-col>
            </v-row>
            <v-row v-if="ligne.linkRobCommandes.length > 0">
              <show-commande-liees
                v-model="ligne"
                type="linking"
                @openPan="canModifyLigne"
                :aleat="aleat"
              />
            </v-row>
            <v-row>
              <v-col>
                {{ ligne.matchingsCommands.length }}
                {{ $t("ligneRob.dialog.chapitre.propose") }}
              </v-col>
            </v-row>
            <v-row v-if="ligne.matchingsCommands.length > 0">
              <show-commande-liees
                v-model="ligne"
                type="matching"
                @openPan="canModifyLigne"
                :aleat="aleat"
              />
            </v-row>
            <v-row>
              <v-col>
                {{ listeAutres().length }}
                {{ $t("ligneRob.dialog.chapitre.autre") }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-form ref="formAutre">
                  <v-autocomplete
                    :search-input.sync="searchAutre"
                    filled
                    :items="listeAutres()"
                    :item-text="getCommandeTitle"
                    item-value="id"
                    clearable
                    @change="addAutre"
                  />
                </v-form>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ commandesNoCa.length }}
                {{ $t("ligneRob.dialog.chapitre.autreNoCa") }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-form ref="formAutre">
                  <v-autocomplete
                    filled
                    :items="commandesNoCa"
                    :item-text="getCommandeTitle"
                    item-value="id"
                  />
                </v-form>
              </v-col>
            </v-row>
          </v-container>
          <v-container fluid>
            <v-row>
              <span class="text-h1">{{
                $t("ligneRob.dialog.chapitre.relance")
              }}</span>
            </v-row>
            <v-row>
              <v-card width="100%" v-if="ligne.relance === 'SB' || user.is_dr">
                <v-card-title> Ajouter un commentaire</v-card-title>
                <v-card-text>
                  <v-form>
                    <v-select
                      :disabled="!user.is_dr"
                      v-model="form.typeRelance"
                      item-text="libelle"
                      item-value="id"
                      :items="typeRelances"
                      label="Type de relance"
                    />
                    <v-textarea
                      clearable
                      v-model="form.commentaire"
                      label="Commentaires"
                    />
                  </v-form>
                </v-card-text>
              </v-card>
            </v-row>
            <v-row>
              <v-col>
                <v-card flat v-for="(relance, index) in relances" :key="index">
                  <v-card-title>
                    {{ relance.user_name }} le {{ relance.created_at }}
                  </v-card-title>
                  <v-card-subtitle>
                    {{ relance.type_relance_name }}
                  </v-card-subtitle>
                  <v-card-text>
                    <div
                      v-html="sanitizedTextContent(relance.commentaire)"
                      class="mb-2"
                    />
                    <v-divider />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="relances.length > 0 && !user.is_dr && ligne.relance === 'SB'"
        color="color_action"
        @click="changeComm()"
      >
        <v-icon left dark> mdi-check</v-icon>
        {{ $t("relance.close") }}
      </v-btn>
      <v-spacer />
      <v-btn color="color_action " @click="myClose()">
        <v-icon left dark> mdi-check</v-icon>
        {{ $t("btn.submit") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { commandeMixin } from "@/mixins/commande";
import { generalMixin } from "@/mixins/general";
import headDialogLink from "@/components/core/headDialogLink";
import showCommandeLiees from "@/components/showCommandeLiees";
import { libUtilMixin } from "@/mixins/libUtilMixin";
import { userMixin } from "@/mixins/user";
import showAttrLigne from "@/components/showAttrLigne";
import { commandeLigne } from "@/common/lib";
import { relanceMixin } from "@/mixins/relance";
import { sanitizedTextContent } from "@/common/lib";
import { tvaMixin } from "@/mixins/tva";

export default {
  name: "VueChoiceCommand",
  components: {
    headDialogLink,
    showCommandeLiees,
    showAttrLigne,
  },
  mixins: [
    commandeMixin,
    generalMixin,
    libUtilMixin,
    userMixin,
    relanceMixin,
    tvaMixin,
  ],
  data() {
    return {
      aleat: Date.now(),
      modify_ligne: true,
      ligne: {},
      ready: false,
      searchAutre: "",
      sanitizedTextContent: sanitizedTextContent,
      form: null,
    };
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    closeDialog: {
      type: Function,
      default: null,
    },
  },

  methods: {
    closePopup() {
      this.aleat = Date.now();
      this.closeDialog();
    },
    canModifyLigne({ canModify }) {
      this.modify_ligne = canModify;
    },
    croise() {
      this.ligne.matchingsCommands = commandeLigne(this.ligne, this.commandes);
    },
    myClose() {
      if (this.form.commentaire.trim() !== "") this.ligne.form = this.form;
      this.$emit("input", this.ligne);
      this.closeDialog();
    },
    listeAutres() {
      const lignes = this.ligne.linkRobCommandes;
      const matchingsCommands = this.ligne.matchingsCommands;
      const a = this.commandes.map(function (commande) {
        const isLiee =
          lignes !== undefined
            ? lignes.findIndex(function (l) {
                return (
                  l.commande !== undefined && l.commande.id === commande.id
                );
              }) !== -1
            : false;
        const isMatching =
          matchingsCommands !== undefined
            ? matchingsCommands.findIndex(function (l) {
                return (
                  l.commande !== undefined && l.commande.id === commande.id
                );
              }) !== -1
            : false;
        if (!isLiee && !isMatching) return commande;
      });
      return a;
    },
    montantGlobal() {
      return this.arrondi2(
        this.ligne.montant_ttc -
          this.ligne.linkRobCommandes.reduce(
            (partialSum, a) => partialSum + a.montant_ttc,
            0
          )
      );
    },
    scrollToTop: function () {
      const a = document.getElementById("headDialog");
      if (a) document.getElementById("headDialog").scrollIntoView();
    },
    addAutre(item) {
      if (!this.user.is_dr) return;
      if (item === null) return null;
      let commande = Object.assign(
        {},
        this.commandes.find(function (commande) {
          return item === commande.id;
        })
      );
      let val = {
        id: "new",
        commande: commande,
        tva: 0,
        montant_tva: null,
        montant_ttc: null,
        montant_ht: null,
        tax_rate_id: null,
        compteComptable: commande.compteComptable,
        montant_abonnement: commande.montant_abonnement,
        montant_isAbonnement:
          commande.montant_abonnement !== null &&
          commande.montant_abonnement > 0,
      };
      this.ligne.matchingsCommands.push(val);
      this.$refs.formAutre.reset();
      this.searchAutre = "";
    },
    getCommandeTitle(item) {
      return (
        item.numero +
        " (Ligne " +
        item.ligne +
        ") | " +
        this.nbMonnaie(item.montant) +
        " | " +
        item.description +
        " | " +
        item.acheteur
      );
    },
    init() {
      this.ligne = { ...this.value };
      this.croise();
      this.scrollToTop();
      this.getTvas(this.paramsRob.robId);
      this.ready = true;
      this.modify_ligne = true;
      this.form = {
        typeRelance: this.user.is_dr ? 1 : 1000,
        commentaire: "",
      };
    },
    changeComm() {
      if (this.form.commentaire.trim() === "") {
        this.form.commentaire = this.$i18n.t("relance.message.clos");
      } else {
        if (
          this.form.commentaire.trim() === this.$i18n.t("relance.message.clos")
        )
          this.form.commentaire = "";
      }
      this.myClose();
    },
  },
  watch: {
    ligne() {
      this.croise();
    },
    value(current) {
      this.init();
      this.getRelances({ ligne_rob_id: current.id });
    },
  },
  mounted() {
    this.init();
    this.getRelances({ ligne_rob_id: this.value.id });
  },
};
</script>

<style scoped>
.v-select__selection,
.v-select__selection--comma,
.v-select.v-text-field input {
  color: blue !important;
}
</style>
